import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import styleHelper from '@client/shared/styles/styleHelper.scss';
import styles from './termsPage.scss';

const TermsPage = () => {
  const { t } = useTranslation(['terms']);
  const orgNumber = t('terms:published.organisationNumber');
  const box = t('terms:published.box');
  const city = t('terms:published.city');
  return (
    <div className={styles.termsPage}>
      <h1 className={classNames(styleHelper.landingH3, styles.title)}>
        {t('terms:title')}
      </h1>
      <p className={classNames(styleHelper.text17b, styles.allerInfoLeadText)}>
        {t('terms:published.caption')}
      </p>
      <p className={classNames(styleHelper.text17b, styles.allerInfo)}>
        {t('terms:published.name')}
      </p>
      {orgNumber && (
        <p className={classNames(styleHelper.text17b, styles.allerInfo)}>
          {orgNumber}
        </p>
      )}
      {box && (
        <p className={classNames(styleHelper.text17b, styles.allerInfo)}>
          {box}
        </p>
      )}
      {city && (
        <p className={classNames(styleHelper.text17b, styles.allerInfo)}>
          {city}
        </p>
      )}
      {t('terms:content').map((item, captionIndex) => {
        return (
          <>
            <p className={classNames(styleHelper.text4, styles.caption)}>
              {`${captionIndex + 1}. ${item.title}`}
            </p>
            {item.body.map((bodyItem, bodyItemIndex) => {
              const hasTitle = !!bodyItem.title;
              let text;
              if (hasTitle) {
                text = bodyItem.text;
              } else {
                text = `${captionIndex + 1}.${bodyItemIndex + 1}. ${
                  bodyItem.text
                }`;
              }
              return (
                <div key={bodyItemIndex}>
                  {hasTitle && (
                    <p
                      className={classNames(styleHelper.text4, styles.caption)}
                    >
                      {`${captionIndex + 1}.${bodyItemIndex + 1}. ${
                        bodyItem.title
                      }`}
                    </p>
                  )}
                  <p className={classNames(styleHelper.text15, styles.body)}>
                    {text}
                  </p>
                </div>
              );
            })}
          </>
        );
      })}
    </div>
  );
};

TermsPage.propTypes = {};

export default TermsPage;
